export const ADD_ENUM_SUSPENSION_CATEGORY = 'ADD_ENUM_SUSPENSION_CATEGORY';
export const ADD_ENUM_VERTICAL_TYPE = 'ADD_ENUM_VERTICAL_TYPE';
export const ADD_ENUM_RCS_USE_CASE = 'ADD_ENUM_RCS_USE_CASE';
export const ADD_ENUM_10DLC_USE_CASE = 'ADD_ENUM_10DLC_USE_CASE';
export const SET_LOADING_MESSAGE = 'SET_LOADING_MESSAGE';
export const CLEAR_LOADING_MESSAGE = 'CLEAR_LOADING_MESSAGE';
export const ADD_ENUM_SMS_USE_CASE = 'ADD_ENUM_SMS_USE_CASE';
export const ADD_ENUM_COUNTRY = 'ADD_ENUM_COUNTRY';
export const ADD_ENUM_MNO = 'ADD_ENUM_MNO';
